/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Cost_CenterInputs */

const en_admin_resource_form_cost_center = /** @type {(inputs: Admin_Resource_Form_Cost_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost Center`)
};

const de_admin_resource_form_cost_center = /** @type {(inputs: Admin_Resource_Form_Cost_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenstelle`)
};

const es_admin_resource_form_cost_center = /** @type {(inputs: Admin_Resource_Form_Cost_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de costes`)
};

const fr_admin_resource_form_cost_center = /** @type {(inputs: Admin_Resource_Form_Cost_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre de coûts`)
};

const nl_admin_resource_form_cost_center = /** @type {(inputs: Admin_Resource_Form_Cost_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenplaats`)
};

/** @type {(inputs: Admin_Resource_Form_Cost_CenterInputs) => LocalizedString} */
const it_admin_resource_form_cost_center = en_admin_resource_form_cost_center;

/** @type {(inputs: Admin_Resource_Form_Cost_CenterInputs) => LocalizedString} */
const pt_br2_admin_resource_form_cost_center = en_admin_resource_form_cost_center;

/** @type {(inputs: Admin_Resource_Form_Cost_CenterInputs) => LocalizedString} */
const pl_admin_resource_form_cost_center = en_admin_resource_form_cost_center;

/** @type {(inputs: Admin_Resource_Form_Cost_CenterInputs) => LocalizedString} */
const hu_admin_resource_form_cost_center = en_admin_resource_form_cost_center;

/** @type {(inputs: Admin_Resource_Form_Cost_CenterInputs) => LocalizedString} */
const ro_admin_resource_form_cost_center = en_admin_resource_form_cost_center;

/**
* | output |
* | --- |
* | "Cost Center" |
*
* @param {Admin_Resource_Form_Cost_CenterInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_cost_center = /** @type {((inputs?: Admin_Resource_Form_Cost_CenterInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Cost_CenterInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_cost_center(inputs)
	if (locale === "de") return de_admin_resource_form_cost_center(inputs)
	if (locale === "es") return es_admin_resource_form_cost_center(inputs)
	if (locale === "fr") return fr_admin_resource_form_cost_center(inputs)
	if (locale === "nl") return nl_admin_resource_form_cost_center(inputs)
	if (locale === "it") return it_admin_resource_form_cost_center(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_cost_center(inputs)
	if (locale === "pl") return pl_admin_resource_form_cost_center(inputs)
	if (locale === "hu") return hu_admin_resource_form_cost_center(inputs)
	return ro_admin_resource_form_cost_center(inputs)
});
export { admin_resource_form_cost_center as "admin.resource_form.cost_center" }